import Api from './index';

const routePrefix = '/email';

const sendEmail = (message: string) => Api.post(`${routePrefix}/support`, { data: { message } });

const sendEmailLink = () => Api.post(`${routePrefix}/link`);

const sendWelcomeEmail = () => Api.post(`${routePrefix}/trial-welcome`);

export { sendEmail, sendEmailLink, sendWelcomeEmail };
